module.exports = __webpack_public_path__ + "media/images/clock-7483dbd9f94fd42c65db42e4940e60ef.png";